import type { ComponentType } from "react";

import { AnchorsPage } from "./articles/AnchorsPage";
import { AssessmentMatrixPage } from "./articles/AssessmentMatrixPage";
import { RoleBlueprintPage } from "./articles/RoleBlueprintPage";
import { RoundSynthesisPage } from "./articles/RoundSynthesisPage";
import { ScoreBandsPage } from "./articles/ScoreBandsPage";
import { ScoringScalesPage } from "./articles/ScoringScalesPage";
import { SelectionProcessPage } from "./articles/SelectionProcessPage";

export interface GuideArticleMeta {
  slug: string;
  title: string;
  hook: string;
  component: ComponentType;
}

export const GUIDE_ARTICLES: GuideArticleMeta[] = [
  {
    slug: "selection-process",
    title: "Selection process overview",
    hook: "The ten stages from brief to onboard, and what each one produces.",
    component: SelectionProcessPage,
  },
  {
    slug: "role-blueprint",
    title: "Role blueprint & capability dimensions",
    hook: "What a blueprint defines: capability dimensions, required levels, ordering.",
    component: RoleBlueprintPage,
  },
  {
    slug: "scoring-scales",
    title: "Scoring scales",
    hook: "The two scales: 1–10 required level on the blueprint, 1–5 evaluation per candidate.",
    component: ScoringScalesPage,
  },
  {
    slug: "anchors",
    title: "Behavioural anchors",
    hook: "How structured evidence backs every score — and why we insist on it.",
    component: AnchorsPage,
  },
  {
    slug: "round-synthesis",
    title: "Interview round synthesis",
    hook: "Two-phase round analysis: gather evidence, then assess with interviewer feedback weighted over the transcript.",
    component: RoundSynthesisPage,
  },
  {
    slug: "assessment-matrix",
    title: "Assessment matrix",
    hook: "Per-dimension band definitions that calibrate scoring across assessors.",
    component: AssessmentMatrixPage,
  },
  {
    slug: "score-bands",
    title: "Score bands & thresholds",
    hook: "Meets/Exceeds/Below-threshold and the rule shape; why the system never decides hireability.",
    component: ScoreBandsPage,
  },
];

export function findGuideArticle(slug: string | undefined): GuideArticleMeta | undefined {
  if (!slug) return undefined;
  return GUIDE_ARTICLES.find((a) => a.slug === slug);
}
